import { useEffect, useState } from 'react'
import axios from 'lib/axios'

interface UserImportApiStatus {
  data: { enabled: boolean }
}

const useUserImportApiEnabled = (companyId: number): boolean => {
  const [enabled, setEnabled] = useState<boolean>(false)

  useEffect(() => {
    let active = true
    setEnabled(false)

    if (companyId > 0) {
      axios.get<UserImportApiStatus>(`/company/${companyId}/user-import-api`)
        .then((response) => {
          if (active) setEnabled(response.data.data.enabled === true)
        })
        .catch(() => {
          if (active) setEnabled(false)
        })
    }

    return () => { active = false }
  }, [companyId])

  return enabled
}

export default useUserImportApiEnabled
